exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".divBox[data-v-8c543afc]{margin:0}.add-height[data-v-8c543afc]{height:250px !important}.alert[data-v-8c543afc]{height:42px;background:#edf5ff;border:1px solid #97c3ff;border-radius:6px;line-height:42px;font-size:13px;font-weight:400;color:#606266;padding-left:20px;margin-bottom:30px}.look[data-v-8c543afc]{font-style:italic;cursor:pointer}\n", ""]);

// exports
